import React from 'react';
import InfoContainerMD from '../../core/infoContainerMD';
import { Container, Typography } from "@mui/material";
import { incidentsHeadings } from '../configs/incidentsInfoConfig';
import { studentInfo } from "../configs/studentDetailsCardConfig";
import { styles } from "../styles/incidentInfoTab";
import { useTheme } from "@mui/material/styles";
import IncidentLocationMap from "./incidentLocationMap";
import IncidentPhotoEvidence from "./incidentPhotoEvidence";
import IncidentTranslation from "./incidentTranslation";
import DeAnonymizePanel from "./deAnonymizePanel";


const IncidentInfoTab = ({data, handleOpen, updating, setUpdating }) => {
    const theme = useTheme();
    const style = styles(theme);
    return (
        <>
            <IncidentTranslation data={data} />
            <IncidentLocationMap location={data.location} />
            <IncidentPhotoEvidence imageUrls={data.imageUrls} imageMeta={data.imageMeta} imageMetaRaw={data.imageMetaRaw} />
            <DeAnonymizePanel data={data} />
            {data.studentData && (
                <Container sx={style.studentInfoContainer}>
                    <Container sx={style.studentInfoHeader}>
                        <Typography sx={style.studentInfoTitle}>
                            Student Personal Information
                        </Typography>
                    </Container>
                    <InfoContainerMD
                        config={studentInfo}
                        infoData={data.studentData}
                    />
                </Container>
            )}
            <InfoContainerMD
                config={incidentsHeadings}
                infoData={data}
                isIncident={true}
                handleOpen={handleOpen}
                updating={updating}
                setUpdating={setUpdating}
                type={"incidents"}
            />
        </>
    );
};

export default IncidentInfoTab;